export default "__VITE_ASSET__CQI0qzwK__"